export const DEFAULT_CONTENT = {
  brand: { name_pre: "Dre", name_accent: "The Engineer" },
  seo: { title: "Dre The Engineer | André Barros" },
  hero: {
    title_pre: "Dre",
    title_accent: "the Engineer",
    subtitle: "Engineering, mechatronics, and the things I build, research and discover.",
    intro:
      "I'm André Barros, an engineer working across mechatronics, mechanical design, electronics and embedded systems.",
    cta_primary: "View Work",
    cta_secondary: "Get In Touch",
  },
  about: {
    heading: "About",
    portrait:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_maker-portfolio-19/artifacts/ba5cafe635bdd305_1790054668187.jpg",
    name_caption: "André Barros",
    paragraphs: [
      "I'm André Barros, an engineer who loves building things that mix mechanics, electronics and code. My world sits in mechatronics.",
      "I design and prototype end to end, from 3D models and custom electronics to firmware. Beyond the projects, I'm driven by curiosity. I spend a lot of time researching, experimenting and documenting the things I discover.",
    ],
  },
  skills: {
    heading: "What I work with",
    items: [
      { icon: "box", title: "Mechanical Design", desc: "3D modelling, assemblies and technical drawings.", tags: ["Autodesk Inventor", "SolidWorks"] },
      { icon: "circuit", title: "Electronics", desc: "Schematic capture, PCB layout and bring up.", tags: ["PCB Design", "Debugging"] },
      { icon: "cpu", title: "Embedded Systems", desc: "Firmware on ARM Cortex M and microcontrollers.", tags: ["STM32", "C / HAL"] },
      { icon: "wrench", title: "Prototyping & Research", desc: "Rapid prototyping, experiments and automation.", tags: ["Arduino", "Sensors"] },
    ],
  },
  projects: { heading: "Projects" },
  articles: { heading: "Articles & Discoveries" },
  community: {
    name: "The Engineering Collective",
    tagline: "A Discord community for engineers, makers and curious minds.",
    description:
      "A place to share projects, ask for help, swap ideas and learn together across mechanical design, electronics, embedded systems and everything in between.",
    invite: "https://discord.gg/CAZXhKzeC",
    button: "Join on Discord",
    features: [
      "Get help and feedback on your projects",
      "Share CAD models, schematics and builds",
      "Electronics, PCB design and debugging",
      "STM32, Arduino and embedded firmware",
      "Research, discoveries and learning resources",
      "Meet other engineers and makers",
    ],
  },
  contact: {
    heading: "Get in touch",
    subtitle: "Available for engineering collaborations, mechatronics projects and research.",
    phone: "+41 76 752 62 63",
    phone_href: "tel:+41767526263",
    email: "andrepereirabarros@outlook.pt",
    linkedin: "https://www.linkedin.com/in/andrepereirabarros/",
  },
  footer: {
    name: "André Barros",
    linkedin: "https://www.linkedin.com/in/andrepereirabarros/",
    fiverr: "https://www.fiverr.com/s/YLLBxlN",
    upwork: "https://www.upwork.com/freelancers/~010a5bacbdfb5dfdbf?mp_source=share",
  },
};

const isObject = (v) => v && typeof v === "object" && !Array.isArray(v);

export function mergeDeep(base, override) {
  if (!isObject(base)) return override === undefined ? base : override;
  const out = Array.isArray(base) ? [...base] : { ...base };
  if (!isObject(override)) return out;
  for (const key of Object.keys(override)) {
    const bv = base[key];
    const ov = override[key];
    if (isObject(bv) && isObject(ov)) out[key] = mergeDeep(bv, ov);
    else if (ov !== undefined && ov !== null) out[key] = ov;
  }
  return out;
}
